import { applyMiddleware, combineReducers, compose, createStore } from "redux";

import bom from './bom';
import canvas from './canvas';
import canvasMiddleware from './utils/canvasMiddleware';
import { createReduxHistoryContext } from 'redux-first-history';
import dpiWarningMiddleware from './utils/dpiWarningMiddleware';
import gtmMiddleware from './utils/gtmMiddleware';
import imprintArea from './imprintarea';
import { inventories } from './inventories/reducers';
import lite from './lite';
import localStoreMiddleware from './utils/localStoreMiddleware';
import logoEditingMiddleware from './utils/LogoEditingMiddleware';
import { reducers as mainReducers } from './main';
import nextgen from './nextgen';
import price from './price';
import { priceRecalculationResponse } from './ordersummary/reducers';
import sidebar from './sidebar';
import tempSelectedMiddleware from './utils/tempSelectedMiddleware';
import template from './template';
import text from './text';
import { thunk } from 'redux-thunk';
import { upsells } from './upsell';
import userimage from './userimage';

export default function configureStore(history, initialState) {
  // const reducers = {
  //   counter: Counter.reducer,
  //   weatherForecasts: WeatherForecasts.reducer
  // };
  const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({ history });

  const middleware = [
    thunk,
    routerMiddleware,
    gtmMiddleware,
    canvasMiddleware,
    tempSelectedMiddleware,
    logoEditingMiddleware,
    dpiWarningMiddleware,
    localStoreMiddleware,
  ];

  // In development or Staging, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  const isStaging = process.env.REACT_APP_BUILD_ENV === 'staging' || process.env.REACT_APP_BUILD_ENV === 'nlserver';
  if ((isDevelopment || isStaging) && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }
  if (!isDevelopment) {
    // TODO:off comment the following when go live
    //console.log = function () {};
  }

  const rootReducer = combineReducers({
    ...bom.reducers,
    ...price.reducers,
    ...template.reducers,
    ...mainReducers,
    ...imprintArea.reducers,
    ...sidebar.reducers,
    ...canvas.reducers,
    ...userimage.reducers,
    ...text.reducers,
    ...lite.reducers,
    ...nextgen.reducers,
    upsells,
    inventories,
    priceRecalculationResponse,
    router: routerReducer,
  });

  return createStore(rootReducer, initialState, compose(applyMiddleware(...middleware), ...enhancers));
}
